import React from 'react'

import styled from 'styled-components'

import {
  FlagChinese,
  FlagEnglish,
  FlagFrench,
  FlagItalian,
  FlagJapanese,
  FlagSign,
  FlagOther,
  FlagSpanish,
  FlagBrazillian
} from './FlagVariants'

export const Flag = ({ variant }) => {
  const langFlag = () => {
    switch (variant) {
      case 'chinese':
        return <FlagChinese />
      case 'english':
        return <FlagEnglish />
      case 'french':
        return <FlagFrench />
      case 'italian':
        return <FlagItalian />
      case 'japanese':
        return <FlagJapanese />
      case 'signLanguage':
        return <FlagSign />
      case 'portuguese':
        return <FlagBrazillian />
      case 'spanish':
        return <FlagSpanish />
      default:
        return <FlagOther />
    }
  }
  return <StyledSvg>{langFlag()}</StyledSvg>
}

const StyledSvg = styled.svg``
